import { Component, Injector, OnInit } from '@angular/core';
import { AbstractControl, ValidationErrors, FormGroup, FormControl, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppComponentBase } from '@shared/app-component-base';
import { UserServiceProxy, ChangePasswordDto } from '@shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';

export class FormGroupErrorStateMatcher implements ErrorStateMatcher {
  constructor(private formGroup: FormGroup) { }

  public isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control && control.dirty && control.touched && this.formGroup && this.formGroup.errors && this.formGroup.errors.areEqual;
  }
}
@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.css']
})
export class ChangePasswordDialogComponent extends AppComponentBase implements OnInit {

  private static areEqual(c: AbstractControl): ValidationErrors | null {
    const keys: string[] = Object.keys(c.value);
    for (const i in keys) {
      if (i !== '0' && c.value[keys[+i - 1]] !== c.value[keys[i]]) {
        return { areEqual: true };
      }
    }
  }
  public parentFormGroup: FormGroup;
  public passwordsFormGroup: FormGroup;
  public isLoading: boolean;
  public equalMatcher: FormGroupErrorStateMatcher;

  public constructor(
    injector: Injector,
    private userServiceProxy: UserServiceProxy,
    private _dialogRef: MatDialogRef<ChangePasswordDialogComponent>
  ) {
    super(injector);
  }

  public ngOnInit() {
    this.isLoading = true;
    this.passwordsFormGroup = new FormGroup({
      'newPassword': new FormControl('', [
        Validators.required, Validators.minLength(4)]),
      'repeatNewPassword': new FormControl('', [Validators.required])
    }, ChangePasswordDialogComponent.areEqual);

    this.parentFormGroup = new FormGroup({
      'currentPassword': new FormControl('', [Validators.required]),
      'passwords': this.passwordsFormGroup
    });
    this.equalMatcher = new FormGroupErrorStateMatcher(this.passwordsFormGroup);
    this.doneLoading();
  }
  public updatePassword(formValue: any) {
    const changePasswordDto = new ChangePasswordDto();
    changePasswordDto.currentPassword = formValue.currentPassword;
    changePasswordDto.newPassword = formValue.passwords.newPassword;

    this.isLoading = true;
    this.userServiceProxy.changePassword(changePasswordDto)
      .pipe(
        finalize(() => {
          this.doneLoading();
        })
      )
      .subscribe(success => {
        if (success) {
          abp.message.success(this.l('PasswordChangedSuccessfully'), this.l('Success'));
          this.close(true);
        }
      });
  }
  private doneLoading(): void {
    this.isLoading = false;
  }
  close(result: any): void {
    this._dialogRef.close(result);
  }
}
